import { array, mixed, number, object, string, TestContext } from 'yup';
import { MalfunctionType } from '../../types/malfunction';

const PHOTO_MAX_SIZE = 5000000;

const validatePhoto = (value: File, ctx: TestContext) => {
  if (value.size > PHOTO_MAX_SIZE) {
    return ctx.createError({
      message: 'Malfunction.File.SizeExceeded',
    });
  }

  if (value.type !== 'image/jpeg' && value.type !== 'image/png') {
    return ctx.createError({ message: 'Malfunction.File.NotSupported' });
  }

  return true;
};

export const schema = object({
  name: string().required('Malfunction.Name.Required'),
  vehicle: object({
    value: number().defined(),
    label: string().defined(),
  }).required('Malfunction.Vehicle.Required'),
  type: object({
    value: mixed<MalfunctionType>().required(),
    label: string().ensure(),
  }).required('Malfunction.Type.Required'),
  description: string().ensure(),
  files: array()
    .of(mixed<File>().test(validatePhoto as any))
    .defined(),
});
